import PANEL_TYPES from "core/panelTypes";

const navs = [
  { name: "labels.containers", url: "/asset-management/containers/", icon: "dumpster", role: "tech", panel_type: PANEL_TYPES.WASTE },
  { name: "labels.bridges", url: "/asset-management/containers/", icon: "bridge-water", role: "tech", panel_type: PANEL_TYPES.BRIDGE },
  { name: "labels.devices", url: "/asset-management/devices/", icon: "network-wired", role: "admin" },
  { name: "labels.groups", url: "/asset-management/groups/", icon: "object-group", role: "tech", panel_type: PANEL_TYPES.WASTE  },
  { name: "labels.device-groups", url: "/asset-management/device_groups/", icon: "object-ungroup", role: "admin"},
  { name: "labels.island", url: "/asset-management/islands/", icon: "boxes-stacked", role: "tech", panel_type: PANEL_TYPES.WASTE },
  { name: "labels.import", url: "/asset-management/imports/", icon: "file-import", role: "admin" },
  { name: "labels.export", url: "/asset-management/exports/", icon: "file-export", role: "admin" }
]

export default navs;